export default __webpack_public_path__ + "static/media/goopter-pudubot-tray-options.61023481.png";